export const SHOW_TIME = "08:00 - 18:00";
export const TEARDOWN_TIME = "18:00 - 23:00";

const valid = (s) => /^(19|20)\d\d-\d\d-\d\d$/.test(s || "");
const shift = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

const eventDays = (start, end) => {
  if (!valid(start)) return [];
  const last = valid(end) && end > start ? end : start;
  const out = [];
  for (let d = start; d <= last && out.length < 60; d = shift(d, 1)) out.push(d);
  return out;
};

// Recomputes setup / show days / teardown from the event range, keeping times already typed.
export const autoSchedule = (q) => {
  const days = eventDays(q.event_date, q.event_date_end);
  if (!days.length) return {};
  const prev = Object.fromEntries((q.show_days || []).map((d) => [d.date, d.time]));
  return {
    days: days.length,
    setup_date: shift(days[0], -1),
    show_days: days.map((date) => ({ date, time: prev[date] || SHOW_TIME })),
    teardown_date: days[days.length - 1],
    teardown_time: q.teardown_time || TEARDOWN_TIME,
  };
};
